import { createFileRoute, redirect } from "@tanstack/react-router"
import { can } from "@/lib/permissions"

export const Route = createFileRoute("/_app/settings/")({
  beforeLoad: ({ context }) => {
    throw redirect({
      to: can(context.session, "management") ? "/settings/organization" : "/settings/profile",
      replace: true,
    })
  },
})
